import React, { useContext } from "react";
import { Context } from "../../../Context";
import { ConfigurationAdministrateView } from "../../views";
import {
  UserService,
  UserTypeService,
  LocalStorageService,
  SignatureProfileService,
  UserSignatureProfileService,
  ContractService,
  Auth0Service
} from "../../../services/index";
import { ValidateInputPure } from "../../pures";
import {
  ConfigurationAdminsitrateValidator,
  RegisterInvitedValidator,
} from "../../../validators";
import { useTranslation } from "react-i18next";
import { withTranslation } from "react-i18next";
import { NIL as NIL_UUID } from 'uuid';


class ConfigurationAdministrateAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      take: 6,
      showPagination: "",
      email: "",
      dataItem: {},

      users: [],
      statusId: 2,
      userType: [],
      userTypeByEmailOne: [],
      userTypeByEmailArray: [],
      visible: false,
      idCounter: 0,

      userInEdit: undefined,
      userInRemove: null,
      dialogTitle: "",

      errorCurrentEmail: false,
      errorCurrentName: false,
      errorCurrentLastName: false,

      messageErrorCurrentEmail: "",
      messageErrorCurrentName: "",
      messageErrorCurrentLastName: "",

      errorUserType: false,
      userTypesSelected: "",
      userTypeSelected: "",
      userContractTypes: "",
      userDocsTypes: "",
      disableUserButton: true,

      showNotification: false,
      message: "Ocurrio un error",
      restOfTheMessage: "",

      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,

      buttonType: 0,
      loading: false,

      visibleDialogDeleteRequest: false,
      saveError: false,
      loadingComponent: false,
      inputValidate: false,
      showErrorDomain: false,
      title: "",
      description: props.t(
        "configurationAdministrationAction.descriptionDialogProfile"
      ),
      editProfileUser: false,
      saveBtn: props.t("button.save"),
      canelBtn: props.t("button.cancel"),
      profilesBtn: props.t("button.profiles"),

      signatureProfilesOriginal: [],
      userSignatureProfilesOriginal: [],
      availableProfiles: [],
      assignedProfiles: [],
      microserviceId: "",
      resultList: [],
      userProfileInEdit: undefined,
      userId: "",

      activeComboGrcContracts: false,
      activeComboGrcDocs: false,

      createUserinGrcContract: false,
      createUserinGrcDocs: false,
      showDialogChangeAdminColab: false,
      acceptBtn: props.t("button.accept")
    };

    this.toggleDialog = this.toggleDialog.bind(this);
    this.onDeleteData = this.onCancelData.bind(this);
  }

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      top: 150,
      right: 30,
      position: "fixed",
    },
  };

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  userService = new UserService(this.url);
  userTypeService = new UserTypeService(this.url);
  signatureProfileService = new SignatureProfileService(this.url);
  userSignatureProfileService = new UserSignatureProfileService(this.url);
  contractService = new ContractService(this.url);
  validator = ConfigurationAdminsitrateValidator(this.props.t);
  namevalidator = RegisterInvitedValidator(this.props.t);
  auth0Service = new Auth0Service();

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    try {
      // Get users collaborators and admins
      let requests = await this.userService.getUserSigners(this.token);
      requests = requests.map((userInfo) => {
        userInfo.userTypeRole = userInfo.userType.name;
        return userInfo;
      });

      // Get users contracts
      const today = new Date();
      let activeComboGrcContracts = false;
      let activeComboGrcDocs = false;
      let contracts = await this.contractService.getContractsByClientId(
        this.token
      );
      if (contracts) {
        for (let i = 0; i < contracts.length; i++) {
          if (new Date(contracts[i].endOfContract) > today) {
            if (
              contracts[i].planLevel.key === "planGrcHibou" ||
              contracts[i].planLevel.key === "planGrcContracts"
            ) {
              activeComboGrcContracts = true;
            }
            if (
              contracts[i].planLevel.key === "planGrcHibou" ||
              contracts[i].planLevel.key === "planGrcDigitalVault"
            ) {
              activeComboGrcDocs = true;
            }
          }
        }
      }

      this.setState({
        users: requests,
        activeComboGrcContracts,
        activeComboGrcDocs,
        loading: false,
        microserviceId: this.user.userMetaData.userMifirma.signatureProfileId,
      });
      let userType = await this.userTypeService.getUsersType(this.token);
      this.setState({
        userType: userType,
      });
      this.setState({
        loadingComponent: false,
      });
      this.onChangeFooterInfoPagination();
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
  }

  /**
   * @author Alan Aguilar
   * @date 19-11-2020
   * @description Change the rendering of a custom footer in the grid
   * @memberof ConfigurationAdministrateAction
   */
  onChangeFooterInfoPagination = () => {
    let paginationInfoExist = document.querySelector(
      "#infoPaginationAdministrate"
    );
    if (paginationInfoExist) {
      paginationInfoExist.remove();
      this.setState({ showPagination: false });
    }

    let { users, take, skip } = this.state;

    let totalItemsInTable = users.length;
    if (users.length !== 0) {
      this.setState({ showPagination: { info: false } }, () => {
        let currentPage = Math.floor(skip / take) + 1;
        let totalPages = Math.ceil((totalItemsInTable || 0) / take);

        let firstItemInPage = skip + 1;
        let lastItemInPage = 0;
        if (currentPage === totalPages) {
          lastItemInPage = totalItemsInTable;
        } else {
          lastItemInPage = skip + take;
        }

        let footerPagination = document.querySelector("div[role='navigation']");
        if (footerPagination) {
          let element = document.createElement("div");
          element.id = "infoPaginationAdministrate";
          element.innerHTML = `<span>${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Firmantes</span> <span style="margin-left: 30px;">${currentPage}/${totalPages}</span>`;
          element.className = "k-pager-info k-label";
          footerPagination.appendChild(element);
        }
      });
    } else {
      this.setState({ showPagination: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to close the alert of the form
   * @memberof SignatureRequestAction
   */
  onCloseOpenModal = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the notification and then close
   * @memberof SignatureRequestAction
   */
  handleMessage = (message) => {
    this.setState(
      {
        showNotification: true,
        message,
      },
      () => {
        setTimeout(() => {
          this.onCloseOpenModal();
        }, 8000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof SignatureRequestAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof SignatureRequestAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show or hide dialog
   * @memberof SignatureRequestAction
   */
  toggleDialog() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Delete
   * @param {Object} dataItem
   * @memberof SignatureReceivePanelAction
   */
  toggleDialogDeleteCollaborator = () => {
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
      disableUserButton: !this.state.disableUserButton
    });
    if (this.state.visibleDialogDeleteRequest === false)
      this.setState({ errorCommentsDelete: false });
  };

  toggleErrorDomain = (value) => {
    this.setState(
      {
        showErrorDomain: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorDomain: false });
        }, 7000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to hide the dialog
   * @memberof SignatureRequestAction
   */
  onCancelData() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Change page in paginnation of table
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  onPageChange = (event) => {
    this.setState(
      {
        skip: event.page.skip,
        take: event.page.take,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Insert new user in the grid
   * @memberof SignatureRequestAction
   */
  insert = () => {
    this.setState({
      userInEdit: {},
      buttonType: 0,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Add a user
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  newUser(dataItem) {
    const id = ++this.idCounter;
    const newUser = {
      id: id,
      email: "",
      userType: "",
    };
    return Object.assign(newUser, dataItem);
  }

  /**
   * @author Lucia Alvarado
   * @description Save data of dialog
   * @memberof SignatureRequestAction
   */
  save = async () => {
    let { email, userTypeSelected, userContractTypes, userDocsTypes } =
      this.state.userInEdit;
    let emailValid = this.validator.emailValidator(email);
    if ((email === null && email === "") || emailValid !== "") {
      this.setState({
        errorCurrentEmail: true,
        messageErrorCurrentEmail: this.props.t(
          "configuration.administrate.action.messageErrorCurrentEmail"
        ),
      });
      return false;
    }
    if (
      userTypeSelected === null ||
      userTypeSelected === "" ||
      userTypeSelected === undefined
    ) {
      this.setState({
        errorUserType: true,
        inputValidate: true,
      });
      return false;
    }

    if (
      userContractTypes === null ||
      userContractTypes === "" ||
      userContractTypes === undefined
    ) {
      this.setState({
        errorUserType: true,
        inputValidate: true,
      });
      return false;
    }

    if (
      userDocsTypes === null ||
      userDocsTypes === "" ||
      userDocsTypes === undefined
    ) {
      this.setState({
        errorUserType: true,
        inputValidate: true,
      });
      return false;
    }

    const dataItem = this.state.userInEdit;
    const users = this.state.users.slice();
    const isNewUser = dataItem.id === undefined;

    if (isNewUser) {
      users.unshift(this.newUser(dataItem));
    } else {
      const index = users.findIndex(
        (p) => p.email === dataItem.email,
        (p) => p.userType === dataItem.userType
      );
      users.splice(index, 1, dataItem);
    }

    this.setState(
      {
        users: users,
        userInEdit: undefined,
        errorNotSigners: false,
        errorCurrentEmail: false,
        messageErrorCurrentEmail: "",
        messageErrorCurrentName: "",
        messageErrorCurrentLastName: "",
        errorUserType: false,
        errorCurrentName: false,
        errorCurrentLastName: false,
        inputValidate: false,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Edit a user
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  edit = (dataItem) => {
    this.setState({
      buttonType: 1,
      userInEdit: this.cloneUser(dataItem),
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Duplicate data user for the grid
   * @param {Object} user
   * @memberof SignatureRequestAction
   */
  cloneUser(user) {
    return Object.assign({}, user);
  }

  /**
   * @author Lucia Alvarado
   * @description Remove a user of grid
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  remove = async (dataItem) => {
    this.setState({
      userInRemove: dataItem,
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
      disableUserButton: !this.state.disableUserButton
    });
  };

  isOnline = (dataItem) => {
    this.user = this.localStorageService.getLocalStorageItem("user");
    if (dataItem.id === this.user.userMetaData.userMifirma.id) {
      return true
    }
    return false
  }
  /**
   * @author Lucia Alvarado
   * @description Method to clear and hide dialog
   * @memberof SignatureRequestAction
   */
  cancel = () => {
    this.setState({
      userInEdit: undefined,
      disableUserButton: true,
      errorCurrentEmail: false,
      messageErrorCurrentEmail: "",
      messageErrorCurrentName: "",
      messageErrorCurrentLastName: "",
      errorUserType: false,
      inputValidate: false,
      editProfileUser: false,
      userProfileInEdit: undefined,
      availableProfiles: undefined,
      assignedProfiles: undefined,
      dataItem: undefined,
      signatureProfilesOriginal: [],
      userSignatureProfilesOriginal: [],
      availableProfiles: [],
      assignedProfiles: [],
    });
  };
  cancelError = () => {
    this.setState({
      saveError: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to change the userTypeSelected in combobox
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  onChangeCombobox = (event) => {
    this.setState({
      userTypesSelected: event.target.value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the title dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  dialogTitle() {
    return `${this.state.userInEdit.id === undefined ? "Agregar firmante" : "Edit"
      } product`;
  }

  /**
   * @author Lucia Alvarado
   * @description Method to save form of the dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  handleSubmit = (event) => {
    event.preventDefault();
    this.save();
    this.setState({ disableUserButton: true });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to change the data of form dialog
   * @updatedDate 24-08-2021
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  onDialogInputChange = (event) => {
    let target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    const edited = this.state.userInEdit;
    edited[name] = value;

    this.setState({
      userInEdit: edited,
      errorCurrentEmail: false,
      messageErrorCurrentEmail: "",
    });

    if (this.state.userInEdit.userTypeSelected !== null) {
      this.setState({
        errorUserType: false,
        disableUserButton: false,
        inputValidate: false,
      });
    } else {
      this.setState({
        errorUserType: true,
        disableUserButton: true,
        inputValidate: true,
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to active the validation of "email" in dialog
   * @updatedDate 24-08-2021
   * @param {Event} event
   * @memberof ConfigurationAdministrateAction
   */
  onBlurValidateEmail = (event) => {
    let target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    let emailValid = "";
    if (name === "email") emailValid = this.validator.emailValidator(value);

    if (this.state.userInEdit.email !== null && emailValid === "") {
      this.setState({
        errorCurrentEmail: false,
        messageErrorCurrentEmail: "",
        disableUserButton: false,
      });
    } else {
      this.setState({
        errorCurrentEmail: true,
        messageErrorCurrentEmail: this.props.t(
          "configuration.administrate.action.messageErrorCurrentEmail"
        ),
        disableUserButton: true,
      });
    }
  };

  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };

  /**
   * @author Lucia Alvarado
   * @description Delete collaborator
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  deleteCollaborator = async () => {
    if (this.state.notification === true) this.onCloseOpenModal();

    try {
      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(true);
      let response = await this.userService.deleteCollaborator(
        this.state.userInRemove.email,
        this.token
      );

      if (response.statusCode === 200) {
        let requests = await this.userService.getUserSigners(this.token);

        this.setState(
          {
            users: requests,
          },
          () => {
            this.onChangeFooterInfoPagination();
          }
        );
        this.cancel();
      } else if (response.statusCode === -1) {
        this.cancel();
        this.setState({
          showNotification: true,
          message: this.props.t(
            "configuration.administrate.action.userDeleteError"
          ),
        });
      }
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true);
      return true;
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      return false;
    }
  };

  /**
   * @author Lucia Alvarado
   * @description Method to move scroll
   * @memberof SignatureRequestAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  /**
   * @author Lucia Alvarado
   * @date 28-01-2022
   * @description Update lists of dialog Profile
   * @memberof ConfigurationAdministrateAction
   */
  listResult = (availableProfiles, assignedProfiles) => {
    this.setState({
      availableProfiles,
      assignedProfiles,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Dialog for edit list profiles
   * @updatedDate 10-03-2022
   * @param {Object} dataItem
   * @memberof ConfigurationAdministrateAction
   */
  profile = async (dataItem) => {
    let backendStatusCode = 0;
    this.setState({
      loadingComponent: true,
      buttonType: 2,
      editProfileUser: !this.state.editProfileUser,
      userProfileInEdit: this.cloneUser(dataItem),
      title:
        dataItem.firstName !== " "
          ? this.props.t(
            "configurationAdministrationAction.titleDialogProfile"
          ) +
          dataItem.firstName +
          " " +
          dataItem.firstLastName
          : this.props.t(
            "configurationAdministrationAction.titleDialogProfile"
          ) + dataItem.email,
    });

    try {
      // 1.- Se obtienen todos los perfiles de firma de A3FD (microserviceId=2 osea con el defautlSignatureProfile=false)
      let signatureProfiles =
        await this.signatureProfileService.getSignatureProfiles(this.token);
      if (!signatureProfiles.data || signatureProfiles.statusCode != 200) {
        backendStatusCode = signatureProfiles.statusCode;
        throw new Error();
      }

      // 2.- Se obtienen todos los perfiles de firma ya asignados a el usuario.
      let userSignatureProfiles =
        await this.userSignatureProfileService.getUserSignatureProfiles(
          this.token,
          this.state.userProfileInEdit.id
        );
      if (
        !userSignatureProfiles.data ||
        userSignatureProfiles.statusCode != 200
      ) {
        backendStatusCode = userSignatureProfiles.statusCode;
        throw new Error();
      }

      // 3.- Se almacena una copia de esta información en el state
      this.setState({
        signatureProfilesOriginal: signatureProfiles.data,
        userProfileOriginal: userSignatureProfiles.data,
      });

      // 4.- Se añade la propiedad selected y namea cada elemento de la lista de signatureProfiles
      signatureProfiles.data = signatureProfiles.data.map((profileDefault) => {
        profileDefault.selected = false;
        return profileDefault;
      });

      // 5.- Se añade la propiedad selected y name a cada elemento de la lista de userSignatureProfiles
      userSignatureProfiles.data = userSignatureProfiles.data.map((profile) => {
        if (userSignatureProfiles.data) {
          profile.selected = false;
          profile.name = profile.signatureProfile.name;
        }
        return profile;
      });

      // 6.- Si userSignatureProfiles contiene datos, entonces en la tabla signatureProfile se filtraran los repetidos
      if (userSignatureProfiles.data) {
        let verifiedAvaibleList = []; // Tabla izquierda
        let verifiedAssignedList = []; // Tabla derecha

        // 7.- Llenar lista para tabla derecha (verifiedAssignedList)
        for (let i = 0; i < userSignatureProfiles.data.length; i++) {
          verifiedAssignedList.push({
            userId: userSignatureProfiles.data[i].userId,
            signatureProfileId:
              userSignatureProfiles.data[i].signatureProfileId,
            selected: userSignatureProfiles.data[i].selected,
            name: userSignatureProfiles.data[i].name,
          });
        }

        // 8.- Se filtran los valores no repetidos obtenidos de signatureProfiles
        let signatureProfileAvailableFiltered = signatureProfiles.data.filter(
          (obj1) => {
            return !userSignatureProfiles.data.some((obj2) => {
              return obj1.id === obj2.signatureProfileId;
            });
          }
        );

        // 9.- Llenar lista para tabla izquierda (verifiedAvaibleList)
        verifiedAvaibleList = signatureProfileAvailableFiltered.map((item) => {
          let result = {
            userId: item.user.id,
            signatureProfileId: item.id,
            selected: item.selected,
            name: item.name,
          };
          return result;
        });

        // 10.- Se almacenan los valores en el state
        this.setState({
          availableProfiles: verifiedAvaibleList,
          assignedProfiles: verifiedAssignedList,
          loadingComponent: false,
        });
      } else {
        this.setState({
          availableProfiles: signatureProfiles.data,
          assignedProfiles: userSignatureProfiles.data,
          loadingComponent: false,
        });
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      return false;
    }
  };

  handleSubmitProfile = async (e) => {
    let backendStatusCode = 0;
    e.preventDefault();

    let {
      availableProfiles,
      assignedProfiles,
      userProfileOriginal,
      userProfileInEdit,
    } = this.state;
    const userId = userProfileInEdit.id;

    // Filtrar perfiles por agregar al usuario
    let assignedSignatureProfilesFiltered = assignedProfiles.filter((obj1) => {
      return !userProfileOriginal.some((obj2) => {
        return obj1.signatureProfileId === obj2.signatureProfileId;
      });
    });

    // Filtrar perfiles por eliminar del usuario
    let deletedSignatureProfilesFiltered = availableProfiles.filter((obj1) => {
      return userProfileOriginal.some((obj2) => {
        return obj1.signatureProfileId === obj2.signatureProfileId;
      });
    });

    try {
      if (
        assignedSignatureProfilesFiltered.length <= 0 &&
        deletedSignatureProfilesFiltered.length <= 0
      )
        return false;
      this.setState({ loadingComponent: true });

      // Agregar perfil de firma a usurio
      if (assignedSignatureProfilesFiltered.length > 0) {
        let signatureProfilesToAssign = [];
        for (let i = 0; i < assignedSignatureProfilesFiltered.length; i++) {
          signatureProfilesToAssign.push({
            userId,
            signatureProfileId:
              assignedSignatureProfilesFiltered[i].signatureProfileId,
          });
        }

        let signaturesProfilesAssigned =
          await this.userSignatureProfileService.createProfilesUser(
            signatureProfilesToAssign,
            this.token
          );
        if (signaturesProfilesAssigned.statusCode != 200) {
          backendStatusCode = signaturesProfilesAssigned.statusCode;
          throw new Error();
        }
      }

      // Eliminar perfil de firma de usuario
      if (deletedSignatureProfilesFiltered.length > 0) {
        let signatureProfilesToDelete = [];
        for (let i = 0; i < deletedSignatureProfilesFiltered.length; i++) {
          signatureProfilesToDelete.push({
            userId,
            signatureProfileId:
              deletedSignatureProfilesFiltered[i].signatureProfileId,
          });
        }

        const arrayToDelete = `${JSON.stringify(signatureProfilesToDelete)}`;
        let signaturesProfilesDeleted =
          await this.userSignatureProfileService.deleteUserProfiles(
            arrayToDelete,
            this.token
          );
        if (signaturesProfilesDeleted.statusCode != 200) {
          backendStatusCode = signaturesProfilesDeleted.statusCode;
          throw new Error();
        }
      }

      this.cancel();
      this.setState({ loadingComponent: false });
      await this.toggleCompletedRequesting(true);
      return true;
    } catch (error) {
      this.cancel();
      this.setState({
        loadingComponent: false,
        message: this.props.t(
          "configuration.administrate.action.assignedProfileError"
        ),
        inputValidate: false,
      });
      await this.toggleErrorRequesting(true);
      return false;
    }
  };


  /**
 * @author Edgar Escobedo
 * @description Open dialog admin and chanege to colab
 * @param {Event} event
 * @memberof ConfigurationAdministrateView
 */
  openDialogChangeRolAdminColab = () => {

    this.toggleDialog()
    this.setState({
      loadingComponent: false,
      showDialogChangeAdminColab: true
    })
  }

  /**
 * @author Edgar Escobedo
 * @description If user accept continue with proccess and close session
 * @param {Event} event
 * @memberof ConfigurationAdministrateView
 */
  acceptDialogChangeRolAmdinColab = async () => {

    this.setState({
      showDialogChangeAdminColab: false,
      loadingComponent: true
    })

    //si el usuario acepta y continua con el procesao se hace todo el proceso de actualizar los roles del usuario
    var noAccessContractRole = {
      description: "Sin acceso",
      display: true,
      id: NIL_UUID,
      name: "Sin acceso",
    };

    var noAccessDocsRole = {
      description: "Sin acceso",
      display: true,
      id: 0,
      name: "Sin acceso",
    };

    let roleContractsValided = this.state.userInEdit?.userContractTypes ? this.state.userInEdit.userContractTypes : noAccessContractRole;
    let roleDocsValided = this.state.userInEdit?.roleDocsType ? this.state.userInEdit.roleDocsType : noAccessDocsRole;

    // var createUserinGrcContract = false;
    // var createUserinGrcDocs = false;
    // var userExistInContracts = await this.userService.getUserContractByEmail(this.state.userInEdit.email, true, true, this.token)

    // if ((userExistInContracts && userExistInContracts.data.data.contrato === true) || (userExistInContracts && userExistInContracts.data.data.docs === true)) {
    //   if (this.state.userInEdit.roleContractType.name === '' && roleContractsValided.id !== NIL_UUID) {
    //     createUserinGrcContract = true;
    //   }
    //   if (this.state.userInEdit.roleDocsType.name === '' && Number(roleDocsValided.id) > 0) {
    //     createUserinGrcDocs = true;
    //   }

    //   if ((userExistInContracts && userExistInContracts.data.data.contrato === true && roleContractsValided.id !== NIL_UUID) || (userExistInContracts.data.data.docs === true && Number(roleDocsValided.id) > 0)) {
    //   let createUserinContractsOrGrc = await this.userService.createCollaboratorInGrcContractOrdocs(this.state.userInEdit.firstName, this.state.userInEdit.firstLastName, this.state.userInEdit.secondLastName, this.state.userInEdit.email, roleContractsValided, createUserinGrcContract, roleDocsValided, createUserinGrcDocs, this.user.userMetaData.userA3Cloud.email, this.token);
    //   if (createUserinContractsOrGrc.statusCode !== 200) {
    //     this.setState({
    //       message: this.props.t(
    //         "configuration.administrate.action.errorCreateUserGrcDocs"
    //       ),
    //       inputValidate: false,
    //     });
    //   }
    //   }
    // }

    let userTypeId = this.state.userInEdit.userTypeSelected
      ? this.state.userInEdit.userTypeSelected.id
      : this.state.userInEdit.userType.id;

    let response = await this.userService.updateCollaborator(
      userTypeId,
      this.state.userInEdit.email,
      this.token,
      roleContractsValided,
      roleDocsValided
    );

    if (response.statusCode === 200) {
      let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
      await this.localStorageService.clearLocalStorage();
      await this.localStorageService.setLocalStorageItem(
        "clientLogo",
        logo ? logo : ""
      );
      this.auth0Service.logout();
    } else if (response.statusCode === -1) {
      this.cancel();
      this.setState({
        loadingComponent: false,
        showNotification: true,
        message: this.props.t(
          "configuration.administrate.action.updateUserError"
        ),
        inputValidate: false,
      });
    } else if (response.statusCode === -7) {
      this.cancel();
      this.setState({
        loadingComponent: false,
        showNotification: true,
        message: this.props.t(
          "configuration.administrate.action.updateUserSignRequestError"
        ),
        inputValidate: false,
      });
      await this.toggleErrorRequesting(true);
      return false
    } else {
      await this.toggleErrorRequesting(true);
      return false
    }
  }


  /**
 * @author Edgar Escobedo
 * @description close dialog admin and chanege to colab
 * @param {Event} event
 * @memberof ConfigurationAdministrateView
 */
  closeDialogChangeRolAmdinColab = () => {

    this.setState({
      showDialogChangeAdminColab: false,
      isSelectNoChangeRol: true,
    })
    this.cancel();
    this.props.history.push("/configuration-administer");
    return true
  }




  /**
   * @author Lucia Alvarado
   * @description Handle the submit event
   * @param {Event} event
   * @memberof ConfigurationAdministrateView
   */
  onSubmit = async (e) => {
    e.preventDefault();
    let { email, userTypeSelected } = this.state.userInEdit;
    let emailValid = this.validator.emailValidator(email);
    if ((email === null && email === "") || emailValid !== "") {
      this.setState({
        errorCurrentEmail: true,
        messageErrorCurrentEmail: this.props.t(
          "configuration.administrate.action.messageErrorCurrentEmail"
        ),
      });
      return false;
    }

    try {
      var noAccessContractRole = {
        description: "Sin acceso",
        display: true,
        id: NIL_UUID,
        name: "Sin acceso",
      };

      var noAccessDocsRole = {
        description: "Sin acceso",
        display: true,
        id: 0,
        name: "Sin acceso",
      };

      if (this.state.buttonType === 1) {
        if (this.state.userInEdit.roleContractType.name !== '') {
          noAccessContractRole = {
            description: this.state.userInEdit.roleContractType.name,
            display: true,
            id: this.state.userInEdit.roleContractType.id,
            name: this.state.userInEdit.roleContractType.name,
          };
        }

        if (this.state.userInEdit.roleDocsType.name !== '') {
          noAccessDocsRole = {
            description: this.state.userInEdit.roleDocsType.name,
            display: true,
            id: this.state.userInEdit.roleDocsType.id,
            name: this.state.userInEdit.roleDocsType.name,
          };
        }
      }

      let roleContractsValided = this.state.userInEdit?.userContractTypes ? this.state.userInEdit.userContractTypes : noAccessContractRole;
      let roleDocsValided = this.state.userInEdit?.userDocsTypes ? this.state.userInEdit.userDocsTypes : noAccessDocsRole;

      if (this.state.buttonType !== 1) {
        if (
          userTypeSelected === null ||
          userTypeSelected === "" ||
          userTypeSelected === undefined
        ) {
          this.setState({
            errorUserType: true,
            inputValidate: true,
          });
          return false;
        }
        //crear
        if (this.state.userInEdit.userTypeSelected && this.state.userInEdit) {
          this.setState({ loadingComponent: true });
          let user = await this.userService.createCollaborator(
            this.state.userInEdit.userTypeSelected.id,
            this.state.userInEdit.email,
            this.token,
            roleContractsValided,
            roleDocsValided
          );
          if (user.statusCode === 200) {
            let requests = await this.userService.getUserSigners(this.token);
            this.setState({
              users: requests,
              loading: false,
              inputValidate: false,
              loadingComponent: false,
            });
            this.cancel();
          } else if (user.statusCode === -1) {
            this.setState({
              loadingComponent: false,
              showNotification: false,
              message: this.props.t(
                "configuration.administrate.action.userExists"
              ),
              saveError: true,
              inputValidate: false,
            });
          } else if (user.statusCode === -2) {
            this.setState({
              loadingComponent: false,
              showNotification: false,
              message: this.props.t(
                "configuration.administrate.action.errorDomain"
              ),
              restOfTheMessage: this.props.t(
                "configuration.administrate.action.errorDomainAll"
              ),
              inputValidate: false,
            });
            await this.toggleErrorDomain(true);
            return false;
          }
          else if (user.statusCode === -3) {
            this.setState({
              loadingComponent: false,
              showNotification: false,
              message: this.props.t(
                "configuration.administrate.action.userExistError"
              ),
              inputValidate: false,
            });
            await this.toggleErrorRequesting(true);
            return false;
          }
        } else {
          this.setState({ inputValidate: true });
        }
      } else if (this.state.buttonType === 1) {
        if (
          (this.state.userInEdit.userTypeSelected
            ? this.state.userInEdit.userTypeSelected
            : this.state.userInEdit.userType.id) &&
          this.state.userInEdit
        ) {
          this.setState({ loadingComponent: true });
          let userTypeId = this.state.userInEdit.userTypeSelected
            ? this.state.userInEdit.userTypeSelected.id
            : this.state.userInEdit.userType.id;

          //verificar si el usuario es administrador trata de cambiar su rol a colab

          const userTypeInHibouAdmin = this.user.userMetaData.userMifirma.userType.id
          const emailAdmin = this.user.userMetaData.userMifirma.email

          if (this.state.userInEdit.email === emailAdmin && Number(userTypeInHibouAdmin) === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) && Number(userTypeId) === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)) {

            this.openDialogChangeRolAdminColab()
            return true;
          }

          // var createUserinGrcContract = false;
          // var createUserinGrcDocs = false;
          // var userExistInContracts = await this.userService.getUserContractByEmail(this.state.userInEdit.email, true, true, this.token)

          // if ((userExistInContracts && userExistInContracts.data.data.contrato === true) || (userExistInContracts && userExistInContracts.data.data.docs === true)) {
          //   if (this.state.userInEdit.roleContractType.name === '' && roleContractsValided.id !== NIL_UUID) {
          //     createUserinGrcContract = true;
          //   }
          //   if (this.state.userInEdit.roleDocsType.name === '' && Number(roleDocsValided.id) > 0) {
          //     createUserinGrcDocs = true;
          //   }
          //   if ((userExistInContracts && userExistInContracts.data.data.contrato === true && roleContractsValided.id !== NIL_UUID) || (userExistInContracts.data.data.docs === true && Number(roleDocsValided.id) > 0)) {
          //     let createUserinContractsOrGrc = await this.userService.createCollaboratorInGrcContractOrdocs(this.state.userInEdit.firstName, this.state.userInEdit.firstLastName, this.state.userInEdit.secondLastName, this.state.userInEdit.email, roleContractsValided, createUserinGrcContract, roleDocsValided, createUserinGrcDocs, this.user.userMetaData.userA3Cloud.email, this.token);
          //     if (createUserinContractsOrGrc.statusCode !== 200) {
          //       // this.cancel();
          //       this.setState({
          //         // loadingComponent: false,
          //         // showNotification: false,
          //         message: this.props.t(
          //           "configuration.administrate.action.errorCreateUserGrcDocs"
          //         ),
          //         inputValidate: false,
          //       });
          //     }
          //   }
          // }

          let response = await this.userService.updateCollaborator(
            userTypeId,
            this.state.userInEdit.email,
            this.token,
            roleContractsValided,
            roleDocsValided
          );

          if (response.statusCode === 200) {
            let requests = await this.userService.getUserSigners(this.token);
            this.setState({
              users: requests,
              loading: false,
              inputValidate: false,
              loadingComponent: false,
            });
            this.cancel();
            await this.toggleCompletedRequesting(true);
            return true
          } else if (response.statusCode === -1) {
            this.cancel();
            this.setState({
              loadingComponent: false,
              showNotification: true,
              message: this.props.t(
                "configuration.administrate.action.updateUserError"
              ),
              inputValidate: false,
            });
          } else if (response.statusCode === -7) {
            this.cancel();
            this.setState({
              loadingComponent: false,
              showNotification: true,
              message: this.props.t(
                "configuration.administrate.action.updateUserSignRequestError"
              ),
              inputValidate: false,
            });
          }

          await this.toggleErrorRequesting(true);
          return false
        } else {
          this.setState({ inputValidate: true });
        }
      }
      // else if (this.state.buttonType === 2) { //profile
      //   await this.handleSubmitProfile()
      // }

      await this.toggleCompletedRequesting(true);
      return true;
    } catch (error) {
      return false;
    }
  };

  render() {
    return (
      <ConfigurationAdministrateView
        {...this.state}
        regex={this.regex}
        validator={this.validator}
        validateInput={ValidateInputPure}
        onSubmit={this.onSubmit}
        toggleDialog={this.toggleDialog}
        onCancelData={this.onCancelData}
        history={this.props.history}
        onPageChange={this.onPageChange}
        insert={this.insert}
        save={this.save}
        edit={this.edit}
        isOnline={this.isOnline}
        newUser={this.newUser}
        remove={this.remove}
        cancel={this.cancel}
        onChangeCombobox={this.onChangeCombobox}
        handleSubmit={this.handleSubmit}
        onDialogInputChange={this.onDialogInputChange}
        onBlurValidateEmail={this.onBlurValidateEmail}
        cloneProduct={this.cloneProduct}
        newProduct={this.newProduct}
        handleName={this.handleName}
        handleDescription={this.handleDescription}
        notification={this.notification}
        toolButtonList={this.toolButtonList}
        onCloseOpenModal={this.onCloseOpenModal}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        saveError={this.state.saveError}
        cancelError={this.cancelError}
        toggleDialogDeleteCollaborator={this.toggleDialogDeleteCollaborator}
        toggleErrorRequesting={this.toggleErrorRequesting}
        deleteCollaborator={this.deleteCollaborator}
        loadingComponent={this.state.loadingComponent}
        inputValidate={this.state.inputValidate}
        onChangeFooterInfoPagination={this.onChangeFooterInfoPagination}
        scrollWindow={this.scrollWindow}
        toggleErrorDomain={this.toggleErrorDomain}
        toggleDialogEditProfileUser={this.toggleDialogEditProfileUser}
        profile={this.profile}
        listResult={this.listResult}
        userProfileData={this.userProfileData}
        userInEditProfile={this.userInEditProfile}
        handleSubmitProfile={this.handleSubmitProfile}
        closeDialog={this.closeDialogChangeRolAmdinColab}
        acceptFn={this.acceptDialogChangeRolAmdinColab}
      />
    );
  }
}

function ConfigurationAdministrateActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <ConfigurationAdministrateAction
      {...props}
      t={t}
      setShowError={setShowError}
    />
  );
}
export default withTranslation()(ConfigurationAdministrateActionContainer);

// export { ConfigurationAdministrateActionContainer as default }
